package one.healthium.onboarding.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import one.healthium.domain.paywall.models.PaywallSet
import one.healthium.onboarding.domain.OnboardingModel
import one.healthium.onboarding.navigation.screenDefinition.ScreenGroupComponent

interface OnboardingComponent : ViewModelStoreOwner, WebNavigationOwner {
    val stack: Value<ChildStack<*, ScreenGroupChild>>
    val model: OnboardingModel
    val paywallSet: PaywallSet?

    fun onBackClicked()

    class ScreenGroupChild(val component: ScreenGroupComponent)
}